import { SimpleTradeCompanyListItem } from 'api';
import { TradeCompanyAutocomplete, useFormContext } from 'form';
import { useContext } from 'react';
import { SectionContainer } from 'ui';

import { PurchaseOrderFormContext } from '../../contexts/PurchaseOrderFormContext';
import { CreateFormValues } from '../../pages/PurchaseOrderCreate/PurchaseOrderCreate';

export const SellerPartiesSection = () => {
  const { setValue } = useFormContext<CreateFormValues>();
  const { defaultValues } = useContext(PurchaseOrderFormContext);
  const onSellerChange = (tradeCompany: SimpleTradeCompanyListItem) => {
    if (tradeCompany.currency) {
      setValue('seller_currency', tradeCompany.currency);
    }
    // @ts-expect-error this field is required so setting it to null raises a type error, but we need to reset it because changing the seller changes the available options to this field
    setValue('collection_site_id', null);
  };

  const onProducerChange = () => {
    // @ts-expect-error this field is required so setting it to null raises a type error, but we need to reset it because changing the producer changes the available options to this field
    setValue('production_site_id', null);
  };

  return (
    <SectionContainer title="Parties" columns={2}>
      <TradeCompanyAutocomplete
        name="seller_id"
        label="Seller"
        onlySellers={true}
        excludeKycBanned
        defaultValue={defaultValues?.seller_id}
        required
        onSelectOption={onSellerChange}
        infoTooltip="Company Safi is purchasing the material from."
      />
      <TradeCompanyAutocomplete
        name="producer_id"
        label="Producer"
        onlySellers={true}
        excludeKycBanned
        defaultValue={defaultValues?.producer_id}
        required
        onSelectOption={onProducerChange}
        infoTooltip="Company that produced the material Safi is purchasing."
      />
      <TradeCompanyAutocomplete
        name="seller_agent_id"
        label="Seller agent"
        defaultValue={defaultValues?.seller_agent_id}
        onlySellers={true}
        excludeKycBanned
        infoTooltip="Company or person who facilitated the transaction between Safi and the seller. "
      />
      <TradeCompanyAutocomplete
        name="exporter_id"
        label="Exporter"
        defaultValue={defaultValues?.exporter_id}
        onlySellers={true}
        excludeKycBanned
        infoTooltip="Company that exports the material from the collection country."
      />
    </SectionContainer>
  );
};
